import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { StaffLocationInfoResponseDto, StaffMapTrackingServiceProxy } from "@shared/service-proxies/service-proxies";
import { GMapsService } from "@shared/services/gmap/gmaps.service";
import { GMarker } from "@shared/models/gmap/gmarker.model";
import { GMarkerLabel } from "@shared/models/gmap/gmarket.label.model";
import { GCoordinate } from "@shared/models/gmap/gcoordinate.model";
import { BaseMapModel } from "@shared/models/generic-map/BaseMapModel";

@Component({
	selector: "kt-staff-map-tracking",
	templateUrl: "./staff-map-tracking.component.html",
	styleUrls: ["./staff-map-tracking.component.scss"],
})
export class StaffMapTrackingComponent implements OnInit {
	// @ViewChild("map", { static: false }) mapElement: ElementRef;
	// private _map: google.maps.Map;

	recordId: string;
	locationInfo = new BehaviorSubject<StaffLocationInfoResponseDto>(null);
	genericMapModel: BaseMapModel = new BaseMapModel();

	constructor(private staffMapTrackingService: StaffMapTrackingServiceProxy, private gMapsService: GMapsService, private route: ActivatedRoute) {
		this.route.paramMap.subscribe((params) => {
			this.recordId = params.get("id");

			if (!this.recordId) {
				alert("URL üzerinden bir Id girişi yapın.");
			}
		});
	}

	ngOnInit() {
		this.staffMapTrackingService.getStaffLocationInfo(this.recordId).subscribe({
			next: (data: StaffLocationInfoResponseDto) => {
				this.locationInfo.next(data);
				this.createGenericMapModel();
			},
			error: (err) => {
				alert("Girilen id bilgisini kontrol edin. Lokasyon bilgisi alınamadı: " + err);
			},
		});
	}

	createGenericMapModel(): void {
		const info = this.locationInfo.value; //API'dan gelen veriler
		
		const centerCoordinate = new GCoordinate();
		centerCoordinate.latitude = info.poiEnlem;
		centerCoordinate.longitude = info.poiBoylam;
		this.genericMapModel.initCoordinate = centerCoordinate;
		this.genericMapModel.initZoom = 17;
		this.genericMapModel.title = "Staff Map Tracking";
		this.genericMapModel.type = "Cluster";

		const mapMarkers: GMarker[] = [];

		// MPOI Noktasına ait işlemler
		const poiMarker = new GMarker();
		poiMarker.id = 1;
		poiMarker.title = "Poi Noktası";
		poiMarker.infoWindowContent = [
			{ key: "Mağaza Adı", value: info.magazaAdi },
			{ key: "Personel Adı", value: info.personelAdi },
			{ key: "Mağaza Adresi", value: info.magazaAdres },
			{ key: "Çalışma Günü", value: info.calismaGunu },
			{ key: "Planlanan Giriş", value: info.planlananGirisTarihi },
			{ key: "Planlanan Çıkış", value: info.planlananCikisTarihi },
		];
		poiMarker.position = { latitude: info.poiEnlem, longitude: info.poiBoylam };
		poiMarker.label = new GMarkerLabel();
		poiMarker.color = "Red";
		poiMarker.hasClickEvent = true;

		mapMarkers.push(poiMarker); //MPOI noktası marker olarak ekleniyor.

		// Giriş yapılan noktaya ait işlemler
		const checkinMarker = new GMarker();
		checkinMarker.id = 2;
		checkinMarker.title = "Giriş Noktası";
		checkinMarker.infoWindowContent = [
			{ key: "Mağaza Adı:", value: info.magazaAdi },
			{ key: "Personel Adı:", value: info.personelAdi },
			{ key: "Çalışma Günü:", value: info.calismaGunu },
			{ key: "Giriş Enlem:", value: info.girisEnlem.toString() },
			{ key: "Giriş Boylam:", value: info.girisBoylam.toString() },
			{ key: "Giriş Tarihi:", value: info.gerceklesenGirisTarihi },
			{ key: "Ana noktaya olan uzaklık (Mt):", value: info.anaNoktayaUzaklikGirisMt.toString() + ' Mt' },
		];

		checkinMarker.position = { latitude: info.girisEnlem, longitude: info.girisBoylam };
		checkinMarker.label = new GMarkerLabel();
		checkinMarker.color = "Blue";
		checkinMarker.hasClickEvent = true;

		mapMarkers.push(checkinMarker); //Giriş yapılan nokta marker olarak ekleniyor.

		// Çıkış yapılan noktaya ait işlemler
		const checkoutMarker = new GMarker();
		checkoutMarker.id = 3;
		checkoutMarker.title = "Çıkış Noktası";
		checkoutMarker.infoWindowContent = [
			{ key: "Mağaza Adı:", value: info.magazaAdi },
			{ key: "Personel Adı:", value: info.personelAdi },
			{ key: "Çalışma Günü:", value: info.calismaGunu },
			{ key: "Çıkış Enlem:", value: info.cikisEnlem.toString() },
			{ key: "Çıkış Boylam:", value: info.cikisBoylam.toString() },
			{ key: "Çıkış Tarihi:", value: info.gerceklesenCikisTarihi },
			{ key: "Ana noktaya olan uzaklık (Mt):", value: info.anaNoktayaUzaklikCikisMt.toString() + ' Mt' },
		];
		checkoutMarker.position = { latitude: info.cikisEnlem, longitude: info.cikisBoylam };
		checkoutMarker.label = new GMarkerLabel();
		checkoutMarker.color = "Green";
		checkoutMarker.hasClickEvent = true;

		mapMarkers.push(checkoutMarker); //Çıkış yapılan nokta marker olarak ekleniyor.

		this.genericMapModel.markers = mapMarkers;
	}
}
